import { Swiper, Thumbs, Navigation } from 'swiper';
import 'swiper/scss';

Swiper.use(Navigation);
Swiper.use(Thumbs);

class GalleryProduct extends HTMLElement {
  constructor() {
    super();
    this.thumbnailSlider = null;
    this.mediaSlider = null;
    this.loopSlides = true;
    this.slidesPerView = 4;
    this.media = [...document.querySelectorAll('[data-slide-media-id')];
    this.$slider = this.querySelector('.js-gallery-product__slider');
    this.$thumbnails = this.querySelector('.js-gallery-product__thumbnails');
    this.$prevBtn = this.querySelector('.js-gallery-product__prev');
    this.$nextBtn = this.querySelector('.js-gallery-product__next');
    if (this?.dataset?.mediaCount) this.setupSlideCount();
    if (this.$slider) this.setupGallery();
  }

  goToSlide(index = 0) {
    this.mediaSlider.slideTo(index);
  }

  showMediaId(mediaId = 0) {
    const mediaTargetId = String(mediaId);
    let targetSlideIndex = false;
    // Using foreach as Array.find throws an error with Swiper
    this.mediaSlider.slides.forEach((slide, index) => {
      if (slide.dataset.slideMediaId === mediaTargetId && !targetSlideIndex) {
        targetSlideIndex = index;
      }
    });
    if (targetSlideIndex) this.goToSlide(targetSlideIndex);
  }

  setupSlideCount() {
    const slideCount = parseInt(this.dataset.mediaCount, 10);
    if (slideCount <= 3) {
      this.slidesPerView = 3;
    }
    if (slideCount < 3) {
      this.loopSlides = false;
    }
  }

  setupGallery() {
    this.thumbnailSlider = new Swiper(this.$thumbnails, {
      loop: this.loopSlides,
      spaceBetween: 10,
      slidesPerView: 3,
      freeMode: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      breakpoints: {
        340: {
          spaceBetween: 20,
          slidesPerView: 3,
        },
        400: {
          spaceBetween: 20,
          slidesPerView: this.slidesPerView,
        },
        640: {
          spaceBetween: 32,
          slidesPerView: this.slidesPerView,
        },
      },
    });

    this.mediaSlider = new Swiper(this.$slider, {
      slidesPerView: 1,
      spaceBetween: 32,
      loop: this.loopSlides,
      thumbs: {
        swiper: this.thumbnailSlider,
      },
      navigation: {
        nextEl: this.$nextBtn,
        prevEl: this.$prevBtn,
      },
    });
  }
}

export default function init() {
  customElements.define('gallery-product', GalleryProduct);
}
